import React from 'react';
import styled from 'styled-components';
import { DisplayIcon } from '@nicheinc/campus-ds';

import { TableMapperType } from '../../types';

export const CircleIconCellWrapper = styled.div`
	display: flex;
	align-items: center;
	column-gap: ${({ theme }) => theme.spacing.medium};
`;

type PropsType = {
	mapperField: TableMapperType;
	item: any;
};

function CircleIconCell({ mapperField, item }: PropsType) {
	return (
		<CircleIconCellWrapper>
			{item[mapperField.key] &&
				item[mapperField.key].map(
					(icon: { id: string; iconName: string }, index: number) =>
						icon.iconName ? (
							<DisplayIcon
								key={index}
								iconName={icon.iconName}
								iconColor="system.background.system"
								bgColor="primary.background.strong"
								round
							/>
						) : (
							<></>
						),
				)}
		</CircleIconCellWrapper>
	);
}

export default CircleIconCell;
